<!--  -->
<template>
 <div>
   <banner/>
    <crumbs/>
    <div class="containerwork">

 <div class="conditioncon-1">
    <div class="overflowbox">
      <div class="overflowinner">
        <ul class="clearfix" v-for="item in cidianList" :key="item.dictName"
        @click="getSelect($event,1)"
        >
          <li>
            <a href="javascript:void(0);">{{item.dictName}}</a>
          </li>
          <li class="cd" v-for="(val,index) in item.list" :key="index"
          :data-code="val.dictCode"
          >
            <a href="javascript:void(0);">{{val.dictName}}</a>
          </li>
        </ul>
        <ul class="clearfix" @click="getSelect($event,2)">
           <li>
            <a href="javascript:void(0);">时间</a>
          </li>
          <li data-code='today' class="cd">
            <a href="javascript:void(0);">今天</a>
          </li>
          <li data-code='week' class="cd">
            <a href="javascript:void(0);">本周</a>
          </li>
          <li data-code='month' class="cd">
            <a href="javascript:void(0);">本月</a>
          </li>
        </ul>
         <ul class="clearfix" @click="getSelect($event,3)">
           <li>
            <a href="javascript:void(0);">状态</a>
          </li>
          <li data-code='0' class="cd">
            <a href="javascript:void(0);">预告中</a>
          </li>
          <li data-code='1' class="cd">
            <a href="javascript:void(0);">进行中</a>
          </li>
          <li data-code='2' class="cd">
            <a href="javascript:void(0);">已结束</a>
          </li>
        </ul>
      </div>
    </div>
 </div>

       <ul class="worksList">
        <li v-for="item in dataList" :key="item.id"
        @click="detaillink(item.id,item.surplusWorksCount,item.status,item.actNumLimit)"
        >
          <div class="statusIcon"
          :class="{
            icon0:item.status.code === 1,
            icon1:item.status.code=== 0,
            icon2:item.status.code ===2
          }"
          >
            {{item.status.description}}
          </div>
          <img :src="item.cover" alt="">
          <h3 class="title">{{item.activityName}}</h3>
          <div class="twoicons">
            <span><i></i>{{item.sponsorUnit}}</span>
            <span><i></i>{{item.startDate.split(' ')[0]}}</span>
          </div>
          <div class="piao" v-if="item.actNumLimit=== 1">
            <span>余票<span class="yupiao">{{item.surplusWorksCount}}</span>/ <span class="allpiao">{{item.actNumber}}</span></span>
          </div>
        </li>

       </ul>
       <el-pagination
        @current-change="handleCurrentChange"
        :page-size="6"
        :pager-count="5"
        layout="prev, pager, next"
        :total="total"
        class="pagemodel1">
      </el-pagination>
    </div>
 </div>
</template>

<script>
import {getWorkList, getCdian} from '@/api/workCollect/index'
import crumbs from '@/components/crumbs/index'
import banner from '@/components/banner/index'
// import typeScreen from '@/components/typescreen/index'
import nodata from '@/components/nodata/index'
export default {
  name: 'workCollect',
  components: {
    // typeScreen,
    crumbs,
    nodata,
    banner
  },
  meta: {
    showHeader: true
  },
  data () {
    return {
      params: {
        page: 1,
        limit: 6,
        menuId: '',
        activityType: null,
        dateType: null,
        status: null
      },
      dataList: [],
      total: 0,
      columnId: '',
      cidianList: []
    }
  },
  created () {
    this.columnId = this.$route.query.columnId
    this.params.menuId = this.$route.query.columnId
    this.getWorkList()
    this.getCdian()
  },
  methods: {
    getSelect (e, type) {
      let code = e.target.parentNode.getAttribute('data-code')
      console.log(e.target.parentNode.parentNode.childNodes)
      let childs = e.target.parentNode.parentNode.childNodes
      for (var i = 0; i < childs.length; i++) {
        if (childs[i].nodeName === 'LI') {
          childs[i].classList.remove('selected')
          console.log(childs[i].classList)
        }
      }
      e.target.parentNode.classList.add('selected')
      if (type === 1) {
        this.params.activityType = code
      } else if (type === 2) {
        this.params.dateType = code
      } else if (type === 3) {
        this.params.status = code
      }
      this.getWorkList()
    },
    getCdian () {
      const param = {
        dictParentCode: 'watlx',
        menuId: this.columnId
      }
      getCdian(param).then(res => {
        console.log(res, '词典')
        this.cidianList = res.data.data.dictType
      })
    },
    getWorkList () {
      getWorkList(this.params).then(res => {
        console.log(res)
        this.total = res.data.data.total
        this.dataList = res.data.data.rows
      })
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getWorkList()
    },
    detaillink (id, surplusWorksCount, status, actNumLimit) {
      this.$router.push({
        path: '/workCollectDetail',
        query: {columnId: this.columnId,
          id: id,
          surplusWorksCount,
          actNumLimit,
          statu: {
            code: status.code,
            description: status.description
          }
        }
      })
    },
    selectType () {}
  },
  beforeDestroy () {

  }
}

</script>

<style lang='scss' scoped>
@import '../../assets/common/scss/works.scss'
</style>



// WEBPACK FOOTER //
// src/view/workCollect/list.vue